import React from 'react'

export default function PaymentTesting(){
    return (
        <div style={{width:'50%',margin:'auto'}}>
            Payment Gateway Testing
        </div>
    )
}